/*Video Widget*/
if (isIE) { // include script for IE. For other browsers, it is included in a promise in functions.js
  var ytTag = document.createElement('script');
  
  ytTag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(ytTag, firstScriptTag);
}


(function($) {

    //Data service for the widget
    function widgetDataService() {

        this.getWidgetData = function(servicePath, widgetModuleItemID, successCallback, errorCallback) {
            $.ajax({
                type: "POST",
                url: servicePath,
                data: "{'widgetModuleItemID':" + widgetModuleItemID + "}",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: successCallback,
                error: errorCallback
            });
        };
    };

    //Global variable for the widget function
    var widgetModuleItemID = 0;
    var widgetData = null;
    var autoPlayNext = false;
    var detectIpad = false;
    var multiVideo = false;
    var trackGA = {}
    var maxVideos = 4;
    var hasImgBg = true;
    var showOnMobile = false;
    var startMuted = true;
    var loopVideo = true;
    var trackingGA = {
      present: false,
      event: 'event',
      gaObj: {
        eventCategory: 'Videos',
        eventAction: '',
        eventLabel: '',
      }
    };
    var alwaysMuted = true;
    var autoPlayVideo = false;
    var playerVars = {'rel': 0, 'loop': 1, 'showinfo': 0, 'playsinline': 1};
    var videoWidgetLoaded = function(){};

    //Constructor for the wiget
    $.fn.videoWidget = function(options) {

        var opts = $.extend({}, $.fn.videoWidget.defaultOptions, options);

        widgetContainer = this;
        widgetModuleItemID = opts.currentWidgetModuleItemID;
        detectIpad = opts.detectIpad;
        multiVideo = opts.multiVideo;
        maxVideos = opts.maxVideos;
        hasImgBg = opts.hasImgBg;
        videoPaginate = opts.videoPaginate;
        showOnMobile = opts.showOnMobile;
        startMuted = opts.startMuted;
        loopVideo = opts.loopVideo;
        autoPlayNext = opts.autoPlayNext;
        alwaysMuted = opts.alwaysMuted;
        autoPlayVideo = opts.autoPlayVideo;
        playerVars = opts.playerVars;
        trackingGA = opts.trackingGA;
        videoWidgetLoaded = opts.videoWidgetLoaded;

        var widgetDataAdapter = new widgetDataService();

        widgetDataAdapter.getWidgetData(opts.scriptPath, opts.currentWidgetModuleItemID, getWidgetDataSuccess, getWidgetDataError);

    };

    //Default options for the constructor to be merged with send constructor data
    $.fn.videoWidget.defaultOptions = {
        scriptPath: "services/eventsservice.asmx",
        currentWidgetModuleItemID: 0,
        detectIpad: false,
        autoPlayNext: false,
        multiVideo: false,
        maxVideos: 4,
        hasImgBg: true,
        showOnMobile: false,
        videoPaginate: false,
        startMuted: true,
        alwaysMuted: true,
        loopVideo: true,
        autoPlayVideo: false,
        trackingGA: {
          present: false,
          event: 'event',
          gaObj: {
            eventCategory: 'Videos',
            eventAction: '',
            eventLabel: '',
          }
        },
        playerVars: {'rel': 0, 'loop': 1, 'showcontrols': 0, 'showinfo': 0, 'playsinline': 1},
        videoWidgetLoaded: function(widgetData){}
    };

    //service call worked
    var getWidgetDataSuccess = function(data) {

        widgetData = data.d;
        // // Lazy load 
        // if (typeof window !== 'undefined' && window.IntersectionObserver) {
        //   var videoWidgetContainer = $('#videoWidget:last-child')[0];
        //   var intObsConfig = {
        //     rootMargin: '200px 0px',
        //     threshold: 0.1
        //   };
        //   var observer = new IntersectionObserver(function (entry, observer) {
        //     if (entry[0].intersectionRatio > 0) {
        //       initialize();
        //       observer.unobserve(entry[0].target);
        //     }
        //   }, intObsConfig);
          
        //   observer.observe(videoWidgetContainer);
        // } else {
        // }
        initialize();

    };




    //service call has failed
    var getWidgetDataError = function(data) {

        console.log('Video Widget failed to load', '\n' + 'Status: ' + data.status + ' ' + data.statusText, '\n' + data.responseText);
    };


    //set up the ui
    function initialize() {
        var countVideos = widgetData.Slides.length;
        var videoIDs = [];
        var playingIndex = 0;

        for (var i = 0; i < countVideos; i ++) {
          videoIDs.push(widgetData.Slides[i].Title);
        }



        if (countVideos > 0) {
            var imagePath = widgetData.Slides[0].ImageWithPath;
            var title = widgetData.Slides[0].Title;
            var description = widgetData.Slides[0].Description;
            var winWidth = $(window).width();
            var checkResponsive = false;
            if (winWidth < mobileSize && isResponsive) {
                checkResponsive = true;
                if (showOnMobile) {
                    checkResponsive = false;
                }
            }

            var imageAlternateText = "";

            if (widgetData.Slides[0].ImageAlternateText != null) {
                imageAlternateText = (widgetData.Slides[0].ImageAlternateText);
            }


            var getWidth = $('div[id="videoWidget"]:last iframe').css('width');
            var getHeight = $('div[id="videoWidget"]:last iframe').css('height');
            getWidth = getWidth.replace('px', '');
            getHeight = getHeight.replace('px', '');
            $('div[id="videoWidget"]:last iframe').remove();
            $('div[id="videoWidget"]').last().prepend('<div id="youtubePlayer"></div>');

            if (countVideos == 1) {
              $('div[id="videoWidget"]:last #videoSection').addClass('single-video');
            }

            if ( multiVideo ) {
              if ( videoPaginate && countVideos > 1 ) {
                $('#videoWidget').append('<div id="arrow-container"><div class="video-arrow previous" data-direction="-1"></div><div class="video-arrow next" data-direction="1"></div></div>');

                $('.video-arrow').click(function() {
                  var direction = playingIndex + parseInt($(this).attr('data-direction'));
                  if (direction < 0) {
                    playingIndex = videoIDs.length - 1;
                  } else if ( direction > videoIDs.length - 1){
                    playingIndex = 0;
                  } else {
                    playingIndex = direction;
                  }
                  if (trackingGA.present && player.getPlayerState() == 1) {
                    console.log(player.getPlayerState());
                    sendGA('Stopped', player.getVideoData().title, player.getCurrentTime());
                  }
                  player.loadVideoById(videoIDs[playingIndex]);
                })
              }
              $('#videoWidget').append('<div id="videoSelector"><div id="videoList"></div></div>');
              var thumbnails = [];

              var i = 0;
              videoIDs.forEach(function (videoID) {

                  var imageAlternateText = "";

                  if (widgetData.Slides[i].ImageAlternateText != null) {
                      imageAlternateText = (widgetData.Slides[i].ImageAlternateText);
                  }

                  thumbnails.push("<div class='video-thumb'><img src='https://img.youtube.com/vi/" + videoID + "/0.jpg' alt=" + imageAlternateText + "></div>");
                  i = i + 1;
              });

              thumbnails.forEach(function(thumbnail) {
                $('#videoWidget #videoSelector #videoList').append(thumbnail);
              });

              $("#videoSelector .video-thumb:first-child").addClass("now-playing");

              $('#videoSelector .video-thumb').click(function() {
                playingIndex = $(this).index();
                $("#videoSelector .video-thumb").removeClass("now-playing");
                $(this).addClass("now-playing");
                if (trackingGA.present && player.getPlayerState() == 1) {
                  sendGA('Paused', player.getVideoData().title);
                }
                player.loadVideoById(videoIDs[playingIndex]);
              });
            }

            var player;

            player = new YT.Player($('div[id="videoWidget"]:last #youtubePlayer')[0], {
                height: '390',
                width: '640',
                videoId: title,
                playerVars: playerVars,
                events: {
                  'onReady': onPlayerReady,
                  'onStateChange': onPlayerStateChange
                }
            });




            // 4. The API will call this function when the video player is ready.
            function onPlayerReady(event) {
              if (autoPlayVideo) {
                event.target.playVideo();
              }
              if (startMuted) {
                event.target.mute();
              }

            }

            // 5. The API calls this function when the player's state changes.
            //    The function indicates that when playing a video (state=1),
            //    the player should play for six seconds and then stop.
            var done = false;

            function onPlayerStateChange(event) {
              var currentTime = event.target.getCurrentTime();
              if (event.data === YT.PlayerState.ENDED) {
                sendGA('Completed', event.target.getVideoData().title);
                if (loopVideo && countVideos < 2) {
                  event.target.playVideo();
                } else if (autoPlayNext && countVideos >= 2) {
                  $('.video-arrow.next').click();
                }
              } else if (event.data === YT.PlayerState.PAUSED && trackingGA.present) {
                setTimeout(function() {
                  if ( event.target.getPlayerState() == 2 ) {
                    sendGA('Paused', event.target.getVideoData().title, event.target.currentTime);
                  }
                }, 1000)
              } else if (event.data === YT.PlayerState.PLAYING && trackingGA.present && currentTime < 1) {
                sendGA('Play', event.target.getVideoData().title);
              }
            }

            function stopVideo() {
                player.stopVideo();
            }

            function unMutePlayer() {
                player.unMute();
            }

            if (!alwaysMuted) {
              $('#videoWidget').mouseenter(function() {
                unMutePlayer();
              });
            }
        } else {
          $('body').addClass('noVideos');
        }

        videoWidgetLoaded(widgetData);  // callback if needed for the constructor
    }

    function sendGA(action, title, time) {
      trackingGA.gaObj.eventAction = action;
      trackingGA.gaObj.eventLabel = title;
      if (time) {
        trackingGA.gaObj.eventValue = time / 60;
      } else if (trackingGA.gaObj.eventValue) {
        delete trackingGA.gaObj.eventValue;
      }
      ga('send', 'event', trackingGA.gaObj);
    }

//
})(jQuery);
